























































import Vue from "vue"
import Component, { mixins } from "vue-class-component";
import { Prop, Emit } from "vue-property-decorator"
import AxiosMixin from "@/mixins/axiosMixin";
import LoadingDialog from "@/components/common/LoadingDialog.vue";

@Component({
  components: {
    LoadingDialog,
  }
})
export default class ImgUploader extends mixins(AxiosMixin) {
  @Prop({ default: "【デジタル社印アップロード】" }) titleText!: string
  @Prop({ default: "デジタル社印画像ファイル" }) fileLabel!: string
  @Prop({ default: "/api/office/officeseal/upload" }) apiPath!: string

  //開いているかどうか
  private isActive = false
  private exists = false
  private isUploaded = false
  //取込ファイル
  private imageFile: File | null = null
  private previewData = ""

  private rules: any = [
    (v: any) => !v || v.size < 3000000 || 'アップロードできません。（最大ファイルサイズ:3MB）',
  ]

  //-------------------------------
  // ダイアログ開く
  //-------------------------------
  public open(exists: boolean) {
    this.exists = exists
    this.isActive = true
    this.imageFile = null
    this.previewData = ""
    this.isUploaded = false
  }

  //-------------------------------
  // ダイアログ閉じる（ダウンロードしたか返却）
  //-------------------------------
  @Emit()
  private close() {
    this.isActive = false
    this.imageFile = null
    this.previewData = ""
    return this.isUploaded
  }

  //-------------------------------
  // キャンセル
  //-------------------------------
  private cancel() {
    this.isUploaded = false
    this.close()
  }

  //-------------------------------
  // 画像アップロード
  //-------------------------------
  private upload() {
    if (this.imageFile == null) {
      alert("デジタル社印が選択されていません。")
      return
    }

    if ((this.$refs as any).fileinput.hasError) {
      alert("アップロードできません。\n画像サイズをご確認ください。")
      return
    }

    if (this.exists) {
      if (!confirm("登録されているデジタル社印を削除します。削除したデータは元に戻りません。\nよろしいですか？")) {
        return
      }
    }
    const formData = new FormData()
    formData.append('image', this.imageFile)
    this.postForm(window.base_url + this.apiPath, formData, res => {
      if (res.data.code > 0) {
        alert(res.data.message)
        return
      }
      this.isUploaded = true
      this.close()
    })
  }

  //-------------------------------
  // 選択画像変更イベント
  //-------------------------------
  private onFileChange(file: File) {
    if (!file) {
      this.imageFile = null
      this.previewData = ""
      return;
    }
    const reader = new FileReader()
    reader.onload = () => {
      // 画像ファイルをbase64文字列にする
      this.previewData = reader.result as string
    }
    // onloadイベント発火
    reader.readAsDataURL(file)
    this.imageFile = file
  }
}
